/**
 * Artwork kart listesi — NEW ZARA JSON import'lu siparişlerde
 * newPriceLabel.variants[].sizes (tek kaynak); legacy'de priceLabel[].sizes.
 *
 * Kids'te katalog priceLabel satırları aynı bedene 07/7 gibi iki kez
 * miktar yazınca çift kart basılıyordu; JSON sizes bu tekrarı engeller.
 */

function normSize(v) {
  const s = String(v ?? '').trim()
  if (!s) return ''
  return /^\d+$/.test(s) ? String(parseInt(s, 10)) : s
}

/**
 * Aktif renk (selectColor) için basılacak beden satırları.
 * JSON: qty > 0 olan variant.sizes
 * Legacy: amount > 0 olan priceLabel sizes
 */
export function getArtworkSizes(data, selectColor) {
  const npl = data?.newPriceLabel
  if (npl?.schemaVersion >= 1 && Array.isArray(npl.variants) && npl.variants.length > 0) {
    const colorCode = data?.priceLabel?.[selectColor]?.colorCode
    const variant =
      (npl.variants || []).find((v) => String(v.colorCode) === String(colorCode)) ||
      npl.variants[selectColor] ||
      null
    return (variant?.sizes || []).filter((s) => Number(s?.qty) > 0)
  }
  return (data?.priceLabel?.[selectColor]?.sizes || []).filter((item) => item.amount > 0)
}

/** Barkod / bıçak-izi sizeCode — JSON: code|size, legacy: sCode */
export function artworkSizeCode(sizeData) {
  if (!sizeData) return ''
  if (sizeData.code != null && String(sizeData.code).trim() !== '') {
    return String(sizeData.code).trim()
  }
  if (sizeData.sCode != null && String(sizeData.sCode).trim() !== '') {
    return String(sizeData.sCode).trim()
  }
  if (sizeData.size != null && String(sizeData.size).trim() !== '') {
    return String(sizeData.size).trim()
  }
  return ''
}

/** Görünen beden adı — Kids: age, yetişkin: EUR/size, legacy: name */
export function artworkSizeName(sizeData) {
  if (!sizeData) return 'Beden'
  if (sizeData.age) return String(sizeData.age)
  if (sizeData.geographic?.EUR) return String(sizeData.geographic.EUR)
  if (sizeData.name) return String(sizeData.name)
  if (sizeData.size != null) return String(sizeData.size)
  return 'Beden'
}

/** sizeData newPriceLabel variant size satırı mı? (legacy amount satırı değil) */
export function isNewPriceLabelSizeRow(sizeData) {
  return (
    sizeData != null &&
    sizeData.size != null &&
    sizeData.qty != null &&
    sizeData.amount === undefined
  )
}

/**
 * bicakIzi param.sizeCode → JSON veya legacy size satırı.
 */
export function findArtworkSizeByCode(sizes, sizeCode) {
  const target = String(sizeCode ?? '').trim()
  const targetNorm = normSize(target)
  if (!target || !Array.isArray(sizes)) return null
  return (
    sizes.find((s) => {
      const code = artworkSizeCode(s)
      if (code === target) return true
      if (normSize(code) === targetNorm) return true
      if (s.size != null && (String(s.size).trim() === target || normSize(s.size) === targetNorm)) {
        return true
      }
      return false
    }) || null
  )
}
